import React from 'react';
import { Section } from './Section';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <Section className="bg-cream" data-id="element-123">
      <div className="flex flex-col items-center text-center mb-10" data-id="element-124">
        <AlertCircle className="w-12 h-12 text-forest mb-4" data-id="element-125" />
        <h2 className="font-serif text-3xl md:text-4xl text-forest font-bold mb-6 max-w-4xl" data-id="element-126">
          El problema no es que te falte disciplina. El problema es que nadie te
          explicó qué hacer de forma simple.
        </h2>
      </div>
      <div className="bg-white rounded-2xl p-8 md:p-10 shadow-md border border-sage" data-id="element-127">
        <p className="text-gray-700 text-lg leading-relaxed mb-6" data-id="element-128">
          Muchas mujeres intentan "comer mejor", hacer más cardio o dejar de
          comer ciertas cosas por completo, pero eso no siempre ayuda a sentirse
          menos inflamada.
        </p>
        <p className="text-gray-700 text-lg leading-relaxed font-medium" data-id="element-129">
          Cuando tu rutina está llena de estrés, comidas rápidas y horarios
          apretados, necesitas algo más práctico: una guía clara, realista y
          fácil de seguir.
        </p>
      </div>
    </Section>;
}